import Toastify from 'toastify-js';

import { apiRequest } from '@common/api/utils';
import { PROGRAM_MAPPING } from './constants';

import rcbTrackings from './trackings';

export const requestCallback = async ({ userProgram, attribution }) => {
  try {
    const res = await apiRequest(
      'POST',
      'request-callback',
      {
        user: {
          program: PROGRAM_MAPPING[userProgram]
              || userProgram,
        },
        attributions: attribution,
      },
    );
    return res;
  } catch (error) {
    throw new Error(error?.responseJson?.message
      || 'Something went wrong! Refresh the page and try again');
  }
};

export const showErrorToast = (errorMessage, formEl) => {
  const errormessage = errorMessage
          || `Something went wrong!
        Refresh the page and try again`;

  Toastify({
    text: errormessage,
    className: 'toastify-danger',
  }).showToast();

  rcbTrackings.formStatusTracking(`${formEl.id}-error`,
    {
      error_message: errormessage,
    });
};
